import React from 'react';
import { featureBlocks } from '../mock';

const DemandChip = ({ chip }) => (
  <div className="card-line p-6 min-h-[220px] flex flex-col justify-between">
    <div className="flex items-center justify-between">
      <span className="eyebrow">{chip.title}</span>
      <span className="pill"><span className="dot-live" />LIVE</span>
    </div>
    <div className="grid grid-cols-7 gap-2 mt-8">
      {chip.days.map((d, i) => (
        <div key={d} className="flex flex-col items-center gap-2">
          <div
            className={`w-full rounded-sm ${
              i === 5 ? 'bg-[#2E6BFF]' : 'bg-white/10'
            }`}
            style={{ height: `${20 + (i * 6) + (i === 5 ? 30 : 0)}px` }}
          />
          <span className="mono text-[10px] text-white/55">{d}</span>
        </div>
      ))}
    </div>
  </div>
);

const OrderingChip = ({ chip }) => (
  <div className="card-line p-6 min-h-[220px] flex flex-col justify-between">
    <div className="grid grid-cols-3 gap-3">
      {chip.lines.map((l) => (
        <div key={l.label} className="border border-white/10 rounded-md p-3">
          <div className="eyebrow mb-2">{l.label}</div>
          <div className="h-sans text-[20px]">{l.value}</div>
        </div>
      ))}
    </div>
    <div className="flex items-center justify-between mt-6">
      <span className="mono text-[12px] text-[#2E6BFF]">{chip.pull}</span>
      <span className="mono text-[12px] text-white/55">{chip.time}</span>
    </div>
  </div>
);

const LaborChip = ({ chip }) => (
  <div className="card-line p-6 min-h-[220px] flex flex-col justify-between">
    <div className="flex items-center justify-between">
      <span className="eyebrow">{chip.title}</span>
    </div>
    <div className="flex items-end justify-between mt-6">
      <div>
        <div className="mono text-[11px] text-white/55">PEAK</div>
        <div className="h-sans text-[56px] text-[#2E6BFF] leading-none">{chip.big}</div>
      </div>
      <div>
        <div className="mono text-[11px] text-white/55">OPEN</div>
        <div className="h-sans text-[32px] text-white/70 leading-none">{chip.lo}</div>
      </div>
    </div>
    <div className="mono text-[11px] text-white/55 mt-4">{chip.range}</div>
  </div>
);

const SupplyChip = ({ chip }) => (
  <div className="card-line p-6 min-h-[220px] flex flex-col justify-between">
    <div>
      <div className="eyebrow mb-2">{chip.title}</div>
      <div className="mono text-[11px] text-white/55">{chip.subtitle}</div>
    </div>
    <div className="grid grid-cols-8 gap-1 mt-6">
      {Array.from({ length: 32 }).map((_, i) => (
        <div
          key={i}
          className={`h-3 rounded-sm ${
            [3, 5, 12, 18, 22, 27].includes(i) ? 'bg-[#2E6BFF]' : 'bg-white/8'
          }`}
          style={{ background: [3, 5, 12, 18, 22, 27].includes(i) ? '#2E6BFF' : 'rgba(255,255,255,0.08)' }}
        />
      ))}
    </div>
    <div className="flex items-center justify-end mt-4">
      <span className="pill"><span className="dot-live" />{chip.status}</span>
    </div>
  </div>
);

const chipFor = (idx, chip) => {
  if (idx === 0) return <DemandChip chip={chip} />;
  if (idx === 1) return <OrderingChip chip={chip} />;
  if (idx === 2) return <LaborChip chip={chip} />;
  return <SupplyChip chip={chip} />;
};

export default function FeatureBlocks() {
  return (
    <section className="section text-white border-t border-white/5">
      <div className="mx-auto max-w-[1400px] px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-16 gap-y-24">
          {featureBlocks.map((f, idx) => (
            <div key={f.number} className="flex flex-col gap-6">
              <div className="flex items-center gap-3">
                <span className="num-marker">{f.number}.</span>
                <span className="eyebrow">{f.tag}</span>
              </div>
              {chipFor(idx, f.chip)}
              <div>
                <h3 className="h-sans text-white text-[26px] mb-3">{f.title}</h3>
                <p className="text-white/55 text-[14.5px] leading-[1.65] max-w-[520px]">
                  {f.body}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
